// src/components/ui/textarea.jsx
"use client"

import * as React from "react"
import PropTypes from "prop-types"

function Textarea({ className, style, ...props }) {
  // Default inline styles for the textarea preview / builder use
  const defaultStyles = {
    boxSizing: "border-box",
    width: "100%",            // responsive full width
    minWidth: 250,            // minimum width in px (adjust if desired)
    minHeight: 120,           // roomy default height (px)
    maxWidth: "100%",
    resize: "vertical",       // allow vertical resize only
    borderRadius: 8,
    border: "1px solid #eef2f6",
    backgroundColor: "#f8fafc",
    padding: "12px 14px",
    fontSize: 16,
    lineHeight: 1.4,
    color: "inherit",
    outline: "none",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    transition: "box-shadow 0.15s ease, border-color 0.15s ease",
  }

  // Merge user-provided style (props.style) after defaults so user overrides work.
  const mergedStyle = { ...defaultStyles, ...(style || {}) }

  return (
    <textarea
      data-slot="textarea"
      style={mergedStyle}
      {...props}
    />
  )
}

Textarea.propTypes = {
  className: PropTypes.string, // kept for compatibility if you pass className
  style: PropTypes.object,     // style override object
}

export { Textarea }
